import { THEME } from '@common/constants/theme.constant';
import React from 'react';
import { css } from 'twin.macro';

export const Line = ({ className }: { className?: string }): JSX.Element => (
    <div className={className} css={styles.line}></div>
);

const styles = {
    line: css`
        border-top: 1px solid ${THEME.GRAY_100};
    `,
};
